import { StackMark } from './Lamp'
import ThemeToggle from './ThemeToggle'
import Constellation from './Constellation'

/**
 * 로그인·비밀번호 찾기/재설정·계정 설정 공통 셸. 왼쪽은 늘 어두운 EDGE 패널, 오른쪽은 폼.
 * 좁은 화면에서는 패널이 위쪽 띠로 줄어든다.
 */
export default function AuthShell({ title, lead, children, footer }: {
  title: string
  lead?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
}) {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-canvas">
      <aside className="relative overflow-hidden bg-bar text-white lg:border-r lg:border-white/5 lg:w-[42%] lg:max-w-xl flex flex-col px-6 py-5 lg:px-12 lg:py-12">
        <Constellation className="hidden lg:block absolute inset-0 w-full h-full" />
        <div className="relative flex items-center gap-3">
          <StackMark />
          <span className="text-[15px] font-semibold tracking-[0.2em]">EDGE</span>
        </div>
        <p className="relative hidden lg:block mt-auto text-xs text-white/35">© DMTEK</p>
      </aside>

      <main className="relative flex-1 flex items-center justify-center px-6 py-12">
        <div className="absolute top-5 right-5"><ThemeToggle /></div>
        <div className="w-full max-w-[360px]">
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900">{title}</h1>
          {lead && <div className="mt-2 text-sm text-gray-500 leading-relaxed">{lead}</div>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 pt-6 border-t border-gray-200 text-sm">{footer}</div>}
        </div>
      </main>
    </div>
  )
}
